/**
 * Whether a booking should be sent to the API as "best available".
 *
 * A guest who picked the table on the floor plan chose it, even when it is
 * also the best available one. The API only records a chosen table when the
 * booking is not best available, so a picked table must never be sent as one.
 */
export const isBookedAsBestAvailable = ({
  isBestAvailable,
  listingId,
  selectedFloorPlanListingIds,
}: {
  isBestAvailable: boolean;
  listingId: string;
  selectedFloorPlanListingIds: string[];
}): boolean =>
  isBestAvailable && !selectedFloorPlanListingIds.includes(listingId);
